<template>
  <cc-container class="detail">
    <cc-header-nav title="来源单据详情">
    </cc-header-nav>
    <cc-main>
      <section class="collapse">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item name="1">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-order"></i>
              <p class="collapse-title">
                来源单据信息
              </p>
            </div>
            <p class="collapse-item">
              订单单号：{{detail.from_number}}
            </p>
            <p class="collapse-item">
              下单时间：{{detail.created_time}}
            </p>
            <!-- 作废状态为 '3' -->
            <p class="collapse-item" v-if="detail.state === '3'">
              作废原因：{{detail.remarks}}
            </p>
          </van-collapse-item>

          <van-collapse-item title="配送信息" name="2" v-if="orderDetail.order">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-position"></i>
              <p class="collapse-title">
                配送信息
              </p>
            </div>
            <p class="collapse-item">
              联系人：{{orderDetail.order.contacter}}
            </p>
            <p class="collapse-item">
              联系电话：{{orderDetail.order.mobile}}
            </p>
            <p class="collapse-item">
              收货单位：{{orderDetail.order.customer_name}}
            </p>
            <p class="collapse-item">
              收货地址：{{orderDetail.order.address}}
            </p>
          </van-collapse-item>
        </van-collapse>
      </section>

      <cc-card>
        <product-list :list="orderDetail.goods" :checkbox="false">
        </product-list>
      </cc-card>

      <section class="summary-box">
        <div>
          <p class="pl10">
            本单总合计：<span class="price">￥{{detail.price}}</span>
          </p>
        </div>
      </section>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Collapse, CollapseItem, Lazyload } from 'vant'
import { types } from '../../../../store/modules/order'
import ProductList from '../components/product-list'
Vue.use(Collapse).use(CollapseItem).use(Lazyload)
export default {
  name: 'refund-detail',
  components: {
    ProductList
  },
  data () {
    return {
      activeNames: '1',
      checked: true,
      detail: {},
      orderDetail: {}
    }
  },
  computed: {
    ...mapGetters(['getRefundInfo', 'getOrderDetail'])
  },
  created () {
    this.loadData()
  },
  destroyed () {
  },
  methods: {
    ...mapActions([types.GET_REFUND_INFO, types.GET_ORDER_DETAIL]),

    async loadData () {
      await Promise.all([
        this.GET_REFUND_INFO({
          id: this.$route.params.id
        }),
        this.GET_ORDER_DETAIL({
          order_number: this.$route.query.order_number
        })
      ])
      this.$tips(this.getRefundInfo, res => {
        this.detail = res
      })
      this.$tips(this.getOrderDetail, res => {
        res.goods = this.normalizeGoods(res.goods)
        this.orderDetail = res
      })
    },
    /**
     * 格式化商品列表数据
     * @param {Array} goods 所有商品
     */
    normalizeGoods: function (goods) {
      var arr = []
      var field = ['exchange', 'gifts', 'lownow', 'putongspecial', 'promotion']
      field.map(key => {
        if (goods[key]) {
          goods[key].map(good => {
            if (key !== 'promotion') {
              arr.push(good)
            } else {
              var promotion = []
              good.map(item => {
                // 用于标识该商品是促销商品
                item._isPromotion = true
                promotion.push(item)
              })
              arr.push(promotion)
            }
          })
        }
      })
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.detail {
  .collapse {
    box-shadow: $box-shadow-base;
    .collapse-title-box {
      @include flex(row);
      align-items: center;
      .collapse-title {
        padding-left: 10px;
      }
    }
    .collapse-item {
      font-size: 12px;
      color: #333;
      margin-left: 40px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 1px solid #EEEEEE;
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .checkbox {
    padding-left: 5px;
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    margin-top: 8px;
    justify-content: space-between;
    padding-right: 10px;
  }
}
.cc-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-order {
  background: url('~assets/img/sprites/order/order.png');
  background-size: 20px 20px;
}
.icon-position {
  background: url('~assets/img/sprites/order/position.png');
  background-size: 20px 20px;
}
</style>
<style lang="scss">
.detail {
  .van-collapse-item__content {
    padding: 0
  }
}
</style>
